import { useEffect, useRef, useState } from 'react';

// 'scroll' is deliberately excluded: layout shifts (e.g. the animated chat demo) fire scroll events without a user.
const ACTIVITY = ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel'];

// Counts down after `idleMs` of no interaction, then calls onReset. `warnMs` before that, `remaining` ticks down.
export function useIdleReset({ enabled, idleMs, warnMs, onReset }) {
  const [remaining, setRemaining] = useState(null);
  const lastActivity = useRef(Date.now());
  const resetRef = useRef(onReset);
  resetRef.current = onReset;

  useEffect(() => {
    if (!enabled) { setRemaining(null); return undefined; }
    lastActivity.current = Date.now();
    const touch = () => { lastActivity.current = Date.now(); setRemaining((r) => (r === null ? r : null)); };
    ACTIVITY.forEach((t) => window.addEventListener(t, touch, { passive: true, capture: true }));
    const tick = setInterval(() => {
      const idle = Date.now() - lastActivity.current;
      if (idle >= idleMs) { resetRef.current(); lastActivity.current = Date.now(); setRemaining(null); return; }
      const left = idleMs - idle;
      setRemaining(left <= warnMs ? Math.ceil(left / 1000) : null);
    }, 500);
    return () => {
      ACTIVITY.forEach((t) => window.removeEventListener(t, touch, { capture: true }));
      clearInterval(tick);
    };
  }, [enabled, idleMs, warnMs]);

  const stay = () => { lastActivity.current = Date.now(); setRemaining(null); };
  return { remaining, stay };
}
